import { render, staticRenderFns } from "./CriteriaItemForm.vue?vue&type=template&id=6c325acc&scoped=true&"
import script from "./CriteriaItemForm.vue?vue&type=script&lang=js&"
export * from "./CriteriaItemForm.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaItemForm.vue?vue&type=style&index=0&id=6c325acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c325acc",
  null
  
)

export default component.exports